import * as tslib_1 from "tslib";
import jump from 'jump.js';
import m from 'mithril';
import { randomKey } from '../../util/formutils';
import { Field } from './field';
export { Input } from './input';
export { Select } from './select';
export { Textarea } from './textarea';
export { Radio } from './radio';
export { Radios } from './radios';
export { Checkbox } from './checkbox';
export { Boxes } from './boxes';
var Fields = /** @class */ (function () {
    function Fields(store, config) {
        this.key = randomKey();
        this.config = {
            fieldClass: Field,
            defaultUnstyled: false,
            defaultRequired: true,
            labelInFields: false
        };
        this.store = store;
        this.config = tslib_1.__assign({}, this.config, config);
    }
    Fields.prototype.status = function () {
        return this.store.status;
    };
    Fields.prototype.asField = function (viewClass, config, children) {
        return m(this.config.fieldClass, this.fieldAttrs(config), m(viewClass, this.viewAttrs(config), children));
    };
    Fields.prototype.defaultFieldAttrs = function (key, rest) {
        var _this = this;
        return tslib_1.__assign({ required: this.config.defaultRequired, unstyled: this.config.defaultUnstyled, name: key }, rest, { id: 'field_' + key + '_' + this.key, value: this.store.data[key], onchange: function (value) { return _this.store.setData(key, value); }, label: this.config.labelInFields ? undefined : rest.label });
    };
    /**
     * Can be used to initialize custom formfields - also used internally
     */
    Fields.prototype.fieldAttrs = function (input) {
        var key = input.key, rest = tslib_1.__rest(input, ["key"]);
        var attrs = this.defaultFieldAttrs(rest.name || key, rest);
        var status = this.status();
        switch (status.type) {
            case 'error':
                return tslib_1.__assign({}, attrs, { errors: status.errors[key], onfocus: function () {
                        if (status.type == 'error')
                            delete status.errors[key];
                    } });
            default:
                return attrs;
        }
    };
    /**
     * This method can be overridden and used to filter certain attributes from passing on to the child element inside.
     * Example: Use this to filter out the label attribute. It can now be drawn in the field view itself.
     */
    Fields.prototype.viewAttrs = function (attrs) {
        return tslib_1.__assign({}, this.fieldAttrs(attrs), { id: undefined, label: this.config.labelInFields ? attrs.label : undefined });
    };
    Fields.prototype.focusField = function (field) {
        jump("#field_" + field + "_" + this.key);
    };
    return Fields;
}());
export { Fields };
